// =====================================================================
//  Controller d'écriture (création/màj) d'une stratégie OTP.
//  Route proxy : PUT /otp-strategy.
// =====================================================================

import {ResponseApi} from "../../Model/ResponseApi.js";
import {JsonFetchJson} from "../../Helper/FetchHelper.js";
import {IOtpStrategyModel} from "../../Model/Otp/OtpStrategyModel.js";
import {OnOtpStrategyUpdate} from "../../Delegates/OtpStrategyDelegate.js";
import {NotificationHelper} from "../../Helper/NotificationHelper.js";

export class OtpUpsert {
    public static Upsert = async (model: IOtpStrategyModel): Promise<IOtpStrategyModel | undefined> => {
        const response = await JsonFetchJson.Put<ResponseApi<IOtpStrategyModel>>("/otp-strategy", model);

        if (response.HasError || !response.Data) {
            const message = response.Errors?.map((e) => e.Message).join(" ") ||
                "La stratégie n'a pas pu être enregistrée";
            NotificationHelper.Instance.error(message);
            return undefined;
        }

        OnOtpStrategyUpdate.Fire(response.Data);
        return response.Data;
    };
}
